<template>
  <div class="index container">
    <!-- <button class="waves-effect waves-light btn-large" @click="test1">Test 1</button>  
    <h1>{{ sheets }}</h1> -->
    <!-- <button @click="test1"></button> -->
    <div class="card small" v-for="sheet in sheets" :key="sheet.id">
      <div class="card-content" @click="goToSheet(sheet.id)">
        <i class="material-icons delete" @click.stop="deleteSheet(sheet.id)">clear</i>
        <div class="title-content-wrapper">
          <h2 class="cardTitle">{{ sheet.title }}</h2>
          <p>{{ sheet.summary }}</p>
        </div>
        <!-- <span class="edit-button btn-floating btn-large halfway-fab">
          <router-link :to="{ name: 'EditSheet', params: {sheet_id: sheet.id}}">
            <i class="material-icons edit">edit</i>
          </router-link>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from '@/helpers/firebase'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters([
      'sheets'
    ])
  },
  mounted() {
    this.getSheets()
  },
  methods: {
    test1() {
      db.collection('sheets').add({
        title: 'Test',
        content:'Writing some trash in here.'
      })
    },
    getSheets () {
      this.$store.dispatch('bindSheets')
    },
    goToSheet(sheetId) {
      this.$router.push({ name: 'EditSheet', params: {sheet_id: sheetId}})
    },
    deleteSheet(id) {
      db.collection('sheets').doc(id).delete()
    }
  }
}
</script>

<style scoped>
.index {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-top: 60px;
}
.edit-button {
  background-color: #D55672;
}
.card {
  border-radius: 10px;
  height: auto;
  padding: 10px;
}
.card:hover {
  color: #19A3BF !important;
}
.card .card-content {
    padding: 30px;
    cursor: pointer;
}
.card h2 {
  margin: 0 0 10px 0;
}
.title-content-wrapper {
  color: #333333
}
.title-content-wrapper:hover {
  color:#19A3BF
}
.cardTitle {
  font-size: 1.6em;
  padding: 0;
  line-height: 1.4em
}
.index .delete{
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  color: #aaa;
  font-size: 1.4em;
}
.index .delete:hover{
  color: #D55672;
  font-size: 1.4em;
}
</style>
